export const DirectorDetails = {
  dateOfBirth: '',
  title: '',
  firstName: '',
  surname: '',
  msisdn: '',
  email: '',
  gender: '',
  positionInCompany: ''
};